
export default {
  name: 'DefaultLayout',

  components: {
    DefaultAppBar: () => import('./AppBar'),
    DefaultDrawer: () => import('./Drawer'),
    DefaultView: () => import('./View'),
  },
  computed: {
    formonly(): boolean {
      return this.$route.query?.view === 'form-only';
    },
  },
};
